import moment from "moment";
import { FC } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { createAlarm, getHeaderAlarmInquiries } from "../../api/alarm.api";
import { RootState } from "../../store/rootReducer";
import { useSelector } from "react-redux";

interface IProps {
  data: any;
  badgeName: string;
  goToUrl: string;
}

const CommonAlarmLine: FC<IProps> = ({data,badgeName,goToUrl}) => {
  const history = useHistory();
  
  const handleClick = async () => {
    history.push(goToUrl);
  }

  return (
    <dd>
      <span className='badge-text'>{badgeName}</span>
      <a href='#' className='tit' onClick={handleClick}>{data.title}</a>
    </dd>
  );
}

export default CommonAlarmLine;
